<template>
  <a href="#!" @click.prevent="openModal"><slot>Upload your Photos</slot></a>
</template>
<script>
import { eventBus } from '../app';

export default {
	props: {},
	data() {
		return {};
	},
	methods: {
		openModal() {
			eventBus.$emit('upload-images');
		}
	}
};
</script>
